import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
/**
 * Ilova ichidagi bildirishnoma — SHARTNOMA.
 *
 * `title` va `body` TAYYOR matn bo'lib keladi (o'zbekcha, backendda
 * quriladi): frontend holat yorliqlarini ikkinchi marta tarjima qilmasligi
 * kerak. Shu sababli bu yerda `kind` dan boshqa "ma'no" yo'q — u faqat
 * ikonka tanlash uchun.
 */
export const notificationSchema = z.object({
    id: z.string(),
    kind: z.string(),
    title: z.string(),
    body: z.string().nullable(),
    entityType: z.string().nullable(),
    entityId: z.string().nullable(),
    isRead: z.boolean(),
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
/**
 * Ro'yxat so'rovi.
 *
 * `onlyUnread` ATAYLAB `boolean` ga o'girilmaydi (`ZodValidationPipe` sxemaning
 * kirish va chiqish turlari bir xil bo'lishini talab qiladi) — o'girish
 * kontrollerda, bir qatorda: `isUnreadOnly`.
 */
export const notificationQuerySchema = paginationQuerySchema.extend({
    onlyUnread: z.enum(['true', 'false']).optional(),
    /**
     * Bitta turdagi xabarlar. Ro'yxatni ham, `unread` hisobini ham
     * cheklaydi: bo'lim yonidagi son faqat O'SHA bo'limning ishini
     * sanashi kerak.
     *
     * Turlar ro'yxati ataylab shartnomada YO'Q: `kind` erkin satr bo'lib
     * qoladi va yangi tur qo'shilganda frontendni qayta yig'ish shart
     * bo'lmaydi.
     */
    kind: z.string().max(40).optional(),
});
/**
 * Bitta HUJJATGA tegishli xabarlarni o'qilgan deb belgilash.
 *
 * Frontend qaysi xabar ekanini bilmaydi — u faqat hujjatni biladi.
 */
export const readEntitySchema = z.object({
    entityType: z.string().min(1).max(40),
    entityId: z.string().regex(/^\d+$/),
});
/** `?onlyUnread=true` — faqat o'qilmaganlar. Boshqa har qanday qiymat "hammasi". */
export const isUnreadOnly = (raw) => raw === 'true';
//# sourceMappingURL=notification.schema.js.map